import { Injectable } from '@angular/core';
import { MultiNotificationConfiguration } from '@core/multi-notification/multi-notification.component';

@Injectable({ providedIn: 'root' })
export class MultiNotificationsService {
  private _notifications: MultiNotificationConfiguration[] = [];

  get notifications() {
    return this._notifications;
  }

  constructor() {}

  addNotification(notification: MultiNotificationConfiguration) {
    this._notifications = [...this.notifications, notification];
  }

  removeNotification(index: number) {
    this._notifications.splice(index, 1);
  }
}

//
// EXAMPLE CONTAINER FOR PARENT TEMPLATE
//
// <div
//   id="component-header"
//   [class]="notificationService?.notifications?.length === 0 ? 'component-header slide-up' : 'component-header'"
// >
//   <app-multi-notification [notifications]="notificationService.notifications" (valueChange)="notificationClicked($event)">
//   </app-multi-notification>
// </div>
//
//
//
// EXAMPLE EVENT HANDLER FOR PARENT COMPONENT
//
//
// notificationClicked(event: { notification: number; action: number }) {
//   console.log(`notificationClicked`, JSON.stringify(event));
//
//   if (event.action === 0) {
//     addOneNotification();
//   } else if (event.action === 1) {
//     addThreeNotifications();
//   } else if (event.action === 2) {
//     this.notificationService.notifications[event.notification].clicked = true;
//     this.notificationService.removeNotification(event.notification);
//   }
// }
//
